import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { NAV_MENUS, SINGLE_LINKS } from './navData';

export default function DesktopNav({ activeMenu, openMenu, closeMenu, textCls, hoverCls }) {
  return (
    <nav className="hidden lg:flex items-center gap-0.5" aria-label="Main navigation">
      {Object.entries(NAV_MENUS).map(([key, { label }]) => (
        <div
          key={key}
          className="relative"
          onMouseEnter={() => openMenu(key)}
          onMouseLeave={closeMenu}
        >
          <button
            className={`flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium ${textCls} ${hoverCls} transition-colors duration-200`}
            aria-expanded={activeMenu === key}
            aria-haspopup="true"
            data-testid={`nav-menu-${key}`}
          >
            {label}
            <ChevronDownIcon
              className={`w-3.5 h-3.5 transition-transform duration-200 ${activeMenu === key ? 'rotate-180' : ''}`}
            />
          </button>
        </div>
      ))}
      {SINGLE_LINKS.map(({ label, href }) => (
        <Link
          key={href}
          to={href}
          className={`px-3 py-2 rounded-md text-sm font-medium ${textCls} ${hoverCls} transition-colors duration-200`}
          data-testid={`nav-link-${href.replace('/', '')}`}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
